import * as t from 'io-ts';
import {
  Template,
  MySafetyHtmls,
  TopRoutes,
  CabData,
  LeaveIntentOffer,
  RouteInfo,
  NameUrl,
  CarTypeInfoDataChecker,
  CarTypeDataChecker,
  InterlinkBlockDataChecker,
  AggregateRating
} from '../../../src/pages/runtime-typechecker';
import { CouponData } from '../RouteTemplate/RouteDataTypeChecker';

export const CityDataForRoute = t.type({
  id: t.number,
  name: t.string,
  description: t.union([t.string, t.null]),
  latitude: t.string,
  longitude: t.string,
  code: t.string,
  placeId: t.string
});
export const RouteData = t.type({
  id: t.number,
  sourceCityId: t.number,
  destinationCityId: t.number,
  isPopular: t.boolean,
  sourceCityData: CityDataForRoute,
  destinationCityData: CityDataForRoute,
  topRoutesfromCity: t.union([t.undefined, TopRoutes]),
  topRoutesToCity: t.union([t.undefined, TopRoutes]),
  description: t.union([t.string, t.null, t.undefined])
});

export const RouteCabInfoChecker = t.type({
  seoUrl: t.union([t.undefined, t.null, t.string]),
  oneWayDistance: t.union([t.undefined, t.null, t.number]),
  oneWayDurationInHrMins: t.union([t.undefined, t.null, t.string])
});
export type RouteCarTypeInfoData = t.TypeOf<typeof RouteCabInfoChecker>;

export const RouteCarTypeTemplateChecker = t.type({
  id: t.number,
  isActive: t.boolean,
  url: t.string,
  description: t.union([t.string, t.null]),
  htmlRefreshDate: t.union([t.string, t.null]),
  created: t.string,
  modified: t.string,
  templateData: Template,
  topRoutesfromCity: t.array(CabData),
  topRoutesToCity: t.array(CabData),
  routeData: RouteData,
  carTypeData: CarTypeDataChecker,
  carTypeRouteCabs: t.array(CabData),
  otherCarTypeRouteCabs: TopRoutes,
  tripType: t.union([t.string, t.undefined]),
  carTypeInfo: CarTypeInfoDataChecker,
  routeCabInfo: RouteCabInfoChecker,
  otherRoutesFromSource: t.union([t.array(RouteInfo), t.undefined]),
  otherRoutesToDestination: t.union([t.array(RouteInfo), t.undefined]),
  nearbyCities: t.union([t.undefined, t.array(NameUrl)]),
  mySafetyHtmls: t.union([t.undefined, MySafetyHtmls]),
  leaveIntentOffers: t.union([t.array(LeaveIntentOffer), t.undefined]),
  hrPackages: t.union([t.array(t.string), t.undefined]),
  interlinks: t.union([t.undefined, t.array(InterlinkBlockDataChecker)]),
  aggregateRating: AggregateRating,
  schemaMinFare: t.number,
  assistedFormOpenDelay: t.number,
  showTripAssistantButton: t.boolean,
  showTripAssistantButtonForDweb: t.boolean,
  showWhatsappWidget: t.boolean,
  whatsappWidgetDeeplink: t.string,
  customerCareNumber: t.string,
  assistantWidgetText: t.string,
  showWhatsAppForAssistedForm: t.boolean,
  showCallUsWidget: t.boolean,
  showCallUsForAssistedForm: t.boolean,
  inboundCallText: t.union([t.string, t.undefined]),
  inboundCallNumber: t.union([t.string, t.undefined]),
  semCustomerCareNumber: t.string,
  semInboundCallNumber: t.union([t.string, t.undefined]),
  showInboundCallNumberInDesktop: t.boolean,
  showCallusModalMweb: t.boolean,
  callusModalOpenDelay: t.number,
  showInboundNumberOnAssistedForm: t.boolean,
  couponInfo: CouponData,
  showLeaveIntentForm: t.boolean,
  whatsappTooltipText: t.string,
  tripAssistanceToolTipText: t.string,
  openTripTypeAndThenDate: t.boolean,
  openDateWidget: t.boolean,
  openTripType: t.boolean,
  packageData: t.any
});

export type RouteCarTypeTemplateData = t.TypeOf<
  typeof RouteCarTypeTemplateChecker
>;
